export function selectInspections() {
    return (state) => state.inspections.current;
}